<template>
    <div class="text-center">
    <template v-if="showButton">
    <!-- <span>{{$auth.driverAssign()}}</span> -->
    <b-button v-if="$auth.hasPermission(config.permissions.order_write) && $auth.driverAssign() == 'Yes'" variant="primary" size="sm" @click="checkDrivers()">{{trans.get('__JSON__.Assign')}}</b-button>
    <i v-else v-b-tooltip="'Need Permission/ Manully Assign Off'" class="mdi mdi-information h4 text-danger"></i>
    </template>
    <b-modal :id="'modal-assign-'+order.order_id"
        lazy
        :ok-title="trans.get('__JSON__.Assign Driver')"
        @show="getDeliveryZones"
        @ok="assignDriver"
        scrollable
        >
        <template #modal-header="{ close }">
            <div class="d-flex justify-content-between w-100">
                <h4 class="mb-0">{{trans.get('__JSON__.Assign Driver')}}</h4>
                <h4 class="mb-0">{{order.order_id}}</h4>
            </div>
            <button type="button" aria-label="Close" class="close" @click="close()"><i class="mdi mdi-close"></i> </button>
        </template>
        <div class="row">
            <div class="col-12">
                <b-form role="form">
                    
                    <div class="order-assign-m">
                        <b-table striped hover :items="drivers || []" :fields="fields">
                            <template #cell(profile_path)="data">
                                <img :src="data.value" class="avatar-xs rounded-circle"
                                    @error="$event.target.src = config.no_image"
                                    alt=""/>
                            </template>
                            <template #cell(firstname)="data">
                                <span>{{data.value +' '+data.item.lastname}}</span>
                            </template>
                            <template #cell(driverid)="data">
                                <b-form-radio
                                    v-model="selected_driver"
                                    :value="data.value"
                                    :id="'order-driver-'+data.value"
                                    name="order-driver-selection"
                                    ></b-form-radio>
                                <span v-if="data.value == currentDriverId" class="badge badge-soft-info ml-1">{{ trans.get('__JSON__.Assigned') }}</span>
                                <span v-else-if="data.value == previousDriverId" class="badge badge-soft-warning ml-1">{{ trans.get('__JSON__.Previous') }}</span>
                            </template>
                        </b-table>
                    </div>
                </b-form>
            </div>
        </div>
    </b-modal>
    </div>

</template>

<script>
import Multiselect from "vue-multiselect";
import config from '../../../config';
import { orderService, vendorService, driverService } from '../../../services'
export default {
    props: {
      order: { default: null },
      showButton: { default: true, type: Boolean },
    },
    components:{Multiselect},
    data(){
        return {
            config: config,
            frenchise_id: '0',
            options: [],
            selected: {last_name:'All',user_id:'0'},
            fields: [
                { key: "profile_path", label: this.trans.get("__JSON__.Profile Image"), sortable: false },
                { key: "firstname", label: this.trans.get("__JSON__.Driver Name",{driver:this.$auth.getDriverName()}), sortable: false },
                { key: "driverid", label: "#", sortable: false },
            ],
            drivers: [],
            selected_driver: null,
            currentDriverId: null,
            previousDriverId: null
        }
    },
    methods:{
        getDriverCustomerType(){
            // order.customer_type: '1' => Private, '5' => Business
            // fa_driver.customer_type: 1 => Business, 2 => Private
            if(this.order.customer_type == '5'){
                return '1';
            }
            return '2';
        },
        checkDrivers(){
            this.$bvModal.show('modal-assign-'+this.order.order_id)
            orderService.checkAvailableDrivers({order_id:this.order.base_id, frenchise_id: this.frenchise_id, customer_type: this.getDriverCustomerType()})
                .then(response => {
                    this.drivers = response.data.result;
                    this.preselectCurrentDriver();
                })
        },
        preselectCurrentDriver(){
            const assigned = (this.order.driver && this.order.driver.length > 0) ? this.order.driver[0] : null;
            const assignedId = assigned ? assigned.driverid : (this.order.driver_id || null);
            const previousId = this.order.previous_driver_id || null;
            this.previousDriverId = previousId && previousId != assignedId ? previousId : null;
            console.log('assignedId', assignedId, 'previousId', previousId, 'this.previousDriverId', this.previousDriverId);
            if(assignedId){
                this.currentDriverId = assignedId;
                this.selected_driver = assignedId;
                if(!this.drivers.some(driver => driver.driverid == assignedId)){
                    if(assigned){
                        this.drivers.push(assigned);
                    }else{
                        driverService.getDriverInfo({driver_id: assignedId})
                            .then(response => {
                                const info = response.data.result;
                                if(info && info.driverid && !this.drivers.some(driver => driver.driverid == info.driverid)){
                                    this.drivers.push(info);
                                }
                            })
                            .catch(() => {});
                    }
                }
                if(this.previousDriverId && !this.drivers.some(driver => driver.driverid == this.previousDriverId)){
                    console.log('previousDriverId', this.previousDriverId);
                    driverService.getPrvDriverInfo({driver_id: this.previousDriverId})
                        .then(response => {
                            const info = response.data.result;
                            console.log('previous driver info', response);
                            if(info && info.driverid && !this.drivers.some(driver => driver.driverid == info.driverid)){
                                this.drivers.push(info);
                            }
                        })
                        .catch(() => {});
                }
            } else {
                this.currentDriverId = null;
                this.selected_driver = null;
                this.previousDriverId = null;
            }
        },
        getDeliveryZones(){
            vendorService.getDeliveryZones()
                .then(response => {
                    this.selected_driver = null;
                    this.options = [{last_name:'All',user_id:'0'},...response.data.result];
                });
        },
        onDeliveryZoneChange(){
            this.frenchise_id = '0';
            if(this.selected){
                this.frenchise_id = this.selected.user_id;
            }
            this.checkDrivers();
        },
        assignDriver(bvModalEvent){
            if(!this.selected_driver){
                bvModalEvent.preventDefault();
                this.$toasted.error(this.trans.get('__JSON__.Please select driver'));
                return false;
            }
            orderService.reassignDriver({
                order_id: this.order.base_id,
                driver_id: this.selected_driver
            })
            .then(response => {
                if(response.data.code == 101){
                    this.$toasted.error(response.data.message);
                    return false;
                }
                this.$toasted.success(response.data.message);
                this.$bvModal.hide('modal-assign-'+this.order.order_id)
                this.$emit('actionChanged')
            })
            .catch(error => {
                this.$toasted.error((error.response && error.response.data && error.response.data.message) ? error.response.data.message : this.trans.get('__JSON__.Something went wrong'));
            })
        }
    }
}
</script>